<template>
  <div class="page">
    <div class="header-menu">
      <navBar v-model='objSave'></navBar>
    </div>
    <div class="page-content">
      <div class="accountRelating">
        <div>
          <img src="/static/img/WeChatLogo.png" />
          <span style="vertical-align: middle">{{$t('system.WeChat')}}</span>
        </div>
        <div @click="ImmediatelyBind">{{$t('system.ImmediatelyBinding')}}</div>
      </div>
    </div>
  </div>
</template>
<script scoped>
  import navBar from '../../modules/navBar.vue'
  export default {
    name: 'accountRelating',
    data() {
      return {
        objSave: {
          centerTitle:'system.AccountAssociated',
          rightTitle: {}
        },
      }
    },
    methods: {
      ImmediatelyBind() {
        let __self = this;
      },
    },
    components: {
      navBar
    }
  }

</script>
<style scoped>
  .header-menu {
    background-color: #12a3ff;
  }

  .accountRelating {
    padding: 0 0.266rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 0.532rem;
    height: 1.995rem;
    background-color: #fff;
    font-size: 0.425rem
  }

  .accountRelating img {
    height: 0.930rem;
    width: 0.930rem;
    margin-right: 0.266rem;
    vertical-align: middle
  }

  .accountRelating div:last-child {
    display: inline-block;
    height: 0.665rem;
    width: 1.995rem;
    border: 1px solid #12a3ff;
    border-radius: 0.532rem;
    text-align: center;
    line-height: 0.798rem;
    height: 0.798rem;
    font-size: 0.345rem;
    color: #12a3ff
  }

</style>
